import { IonAvatar, IonSkeletonText } from '@ionic/react';

import './index.css';

const ChartSkeleton = () => {
  return (
    <div className={'chart-skeleton'}>
      <div className={'chart-skeleton-metrics ion-padding-horizontal'}>
        <IonSkeletonText animated />
        <IonSkeletonText animated />
        <IonSkeletonText animated />
      </div>

      <div className={'ion-padding'}>
        <IonAvatar slot={'start'}>
          <IonSkeletonText animated />
        </IonAvatar>
      </div>
    </div>
  );
};
export default ChartSkeleton;
